import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { defineAsyncComponent } from 'vue';
import { createApp } from 'vue';
import VuePlyr from 'vue-plyr';
import { initMenuMain } from './menu/menu-main';
import { initShieldedSite } from './footer/shielded-site';
import { toggleAccordion } from './accordion/accordionOpen';
import { accordionOpenFromSearch } from './accordion/accordionOpenFromSearch';
import { handleCampaignVideo } from './video/campaign-video';
import { initAnchorMenu } from './anchor_menu/anchor-menu';
import { handleCarousel } from './carousel/carousel';
import { handleAnchorClick } from './anchor_menu/anchor-menu-click';
import { downloadImage } from './image_block/image_block_download';

import {
  initBackToTop,
  showBackToTop,
  handleBackToTop,
} from './back_to_top/back-to-top';

const AudioBlock = defineAsyncComponent(() => import(
  /* webpackChunkName: "AudioBlock" */
  './AudioBlock/AudioBlock.vue'
));

const VideoBlock = defineAsyncComponent(() => import(
  /* webpackChunkName: "VideoBlock" */
  './VideoBlock/VideoBlock.vue'
));

const Search = defineAsyncComponent(() => import('./search/Search.vue'));

const HomepageSearch = defineAsyncComponent(() => import('./search/HomepageSearch.vue'));

const app = createApp({
  components: {
    AudioBlock,
    VideoBlock,
    Search,
    HomepageSearch,
  },
  mounted() {
    initMenuMain();
    initShieldedSite();
    toggleAccordion();
    accordionOpenFromSearch();
    initAnchorMenu();
    handleCampaignVideo();
    handleCarousel();
    handleAnchorClick();
    initBackToTop();
    showBackToTop();
    handleBackToTop();
    downloadImage();
  },
});

app.use(VuePlyr, {
  plyr: {
    settings: [],
    iconUrl:
      '../../themes/custom/education_base/dist/images/vue-plyr-sprite.svg',

    // Override Plyr defaults.
    // https://github.com/sampotts/plyr#getters-and-setters
    controls: [
      'play-large', // The large play button in the center
      'rewind', // Rewind by the seek time (default 10 seconds)
      'play', // Play/pause playback
      'fast-forward', // Fast forward by the seek time (default 10 seconds)
      'progress', // The progress bar and scrubber for playback and buffering
      'current-time', // The current time of playback
      'duration', // The full duration of the media
      'mute', // Toggle mute
      'volume', // Volume control
      // 'captions', // Toggle captions
      // 'fullscreen', // Toggle fullscreen
    ],
  },
});

app.mount('#app');
